<div class="countdown-container">
  <div class="countdown-message">
    <h3>{{ message | translate }}</h3>
    <p class="target-date">
      {{ formattedDate() }} {{ 'timezone_atlanta' | translate }}
    </p>
  </div>

  @if (!isExpired()) {
    <div class="countdown-timer">
      <div class="time-unit">
        <div class="time-value">{{ countdown().days }}</div>
        <div class="time-label">{{ 'days' | translate }}</div>
      </div>
      <div class="time-separator">:</div>
      <div class="time-unit">
        <div class="time-value">{{ pad(countdown().hours) }}</div>
        <div class="time-label">{{ 'hours' | translate }}</div>
      </div>
      <div class="time-separator">:</div>
      <div class="time-unit">
        <div class="time-value">{{ pad(countdown().minutes) }}</div>
        <div class="time-label">{{ 'minutes' | translate }}</div>
      </div>
      <div class="time-separator">:</div>
      <div class="time-unit">
        <div class="time-value">{{ pad(countdown().seconds) }}</div>
        <div class="time-label">{{ 'seconds' | translate }}</div>
      </div>
    </div>
  } @else {
    <div class="countdown-expired">
      <p>{{ 'orders_now_available' | translate }}</p>
    </div>
  }
</div>